<template>
  <Toast/>
  <div class="row">
    <div class="col">
      <h2 class="titre">Importation Vague</h2>
    </div>
  </div>
  <div class="row border-white">
    <div class="col">
      <div class="row">
        <div class="col lbl">
          <label>Numéro Cardex :</label>
        </div>
        <div class="col">
          <InputText type="text" :disabled="true" v-model="numeroCardex"/>
        </div>
        <div class="col"/>
      </div>
      <div class="row">
        <div class="col lbl">
          <label>Fichier à importer :</label>
        </div>
        <div class="col">
          <InputText type="text" :disabled="true" v-model="filename"/>
        </div>
        <div class="col">
          <FileUpload
            mode="basic"
            :accept="ALLOWED_FILETYPES"
            chooseLabel="Parcourir..."
            class="p-button-sm p-button-rounded"
            :customUpload="CUSTOM_UPLOAD"
            :auto="AUTO_UPLOAD"
            @uploader="ajouterFichier"
            :multiple="false"
            ref="fileUpload"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row pt-2">
    <div class="col">
      <div v-if="isImportationEnCours">
        <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
      </div>
      <div v-else>
        <Button label="Importer" @click="importer"/>
      </div>
    </div>
    <div class="col">
      <Button label="Fermer" @click="fermer"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from 'vuex';
export default {
  data() {
    return {
      numeroCardex: null,
      filename: null,
      file: null,
      isImportationEnCours: false
    }
  },
  created() {
    this.ALLOWED_FILETYPES = "text/plain"
    this.AUTO_UPLOAD = true
    this.CUSTOM_UPLOAD = true
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Importation Vague");
    this.numeroCardex = this.dossier.numeroCardex;
  },
  computed: {
    ...mapGetters({
      dossier: 'dossier/dossier',
      jeton: 'cardex/jeton',
      profil: 'cardex/profil'
    })
  },
  methods : {
    ajouterFichier(upload){
      this.filename = upload.files[0].name
      this.file = upload.files[0]
    },
    importer(){
      this.isImportationEnCours = true;
      var reader = new FileReader();
      reader.onload = (function(e) {
        var numerosFiche = []
        var contents = e.target.result;
        numerosFiche = contents.split('\r\n');
        this.$store.dispatch('clientMystere/importationVagueAction', {
          numeroCardex: this.numeroCardex,
          numerosFiche: numerosFiche
        }).then((res) => {
          this.isImportationEnCours = false;
          if (res.data.length > 0) {
            this.addMessage(res.data);
          }else{
              this.$toast.add({
                severity: 'success',
                summary: 'Importation Vague',
                detail: 'Importation réussie!',
                life: 6000
              });
          }
        });
      }).bind(this);
      reader.readAsText(this.file);
    },
    addMessage(messageList) {
      if (messageList && messageList.length > 0) {
        messageList.forEach(m => {
          if (!m.severite) {
            m.severite = 'warn'
          }
        })
      }
      this.$root.$refs.messagesComp.messagesList = messageList
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
